import React from 'react';
import appStoreBadgeSvg from '../../assets/app-store-badge.svg';
import './appStoreBadge.scss';

export const AppStoreBadge = ({ className = '', style = {} }) => {
  return (
    <img 
      src={appStoreBadgeSvg}
      alt="Download on the App Store"
      className={`app-store-badge ${className}`}
      style={style}
    />
  );
};
